import m from "../../geodata/es2015/botswanaHigh";
window.am4geodata_botswanaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/botswanaHigh.js
// module id = null
// module chunks = 